export default "__VITE_ASSET__CXtayENN__"